import { render, staticRenderFns } from "./TeamStatistics.vue?vue&type=template&id=1cd69dc8&scoped=true&"
import script from "./TeamStatistics.vue?vue&type=script&lang=js&"
export * from "./TeamStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd69dc8",
  null
  
)

export default component.exports